export enum SERVICEABILITY_API_ENDPOINTS {
  ADDRESS_ENTITY = '/adsq-orchestrator/v2/sq/address',
  ADDRESS_ENTITY_LOCATION = '/adsq-orchestrator/v2/sq/location/:locationId'
}
